import styled from 'styled-components';

const Tabs = styled.div`
	width: 100%;
`;

export default Tabs;
